import { FeedbackFormProps } from '../FeedbackForm/types';


export enum FeedbackModalStage {
    INIT = 'INIT',
    CONFIRMATION = 'CONFIRMATION',
    FINAL = 'FINAL',
}

export interface FeedbackModalComponentProps extends Partial<FeedbackFormProps> {
    stage: FeedbackModalStage;
    errorMessage?: string | null;
    isError?: boolean;
}
